<template>
  <div class="dialog-wrap">
    <el-dialog title="权限创建"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="680px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="名称"
                      prop="title">
          <el-input v-model="dataForm.title"
                    placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="范围"
                      prop="datarange">
          <el-select v-model="dataForm.datarange"
                     placeholder="请选择"
                     clearable>
            <el-option label="本人"
                       :value="1">
            </el-option>
            <el-option label="本部门"
                       :value="2">
            </el-option>
            <el-option label="本部门及下属部门"
                       :value="3">
            </el-option>
            <el-option label="全部"
                       :value="4">
            </el-option>
            <el-option label="本人产品"
                       :value="5">
            </el-option>
            <el-option label="新媒体账号"
                       :value="6">
            </el-option>
            <el-option label="本人专业数据范围"
                       :value="7">
            </el-option>
            <el-option label="本人指定产品范围"
                       :value="9">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择账号"
                      prop="media_account_ids"
                      v-if="dataForm.datarange==6">
          <el-link type="primary"
                   :underline="false"
                   @click="accountChooseDialog=true">选择账号</el-link>
          <div class="tags-wrap">
            <el-tag :key="index"
                    v-for="(item,index) in accounts"
                    closable
                    :disable-transitions="false"
                    @close="handleTagRemove(item)">
              {{item.name}}/{{formatePlatform_code(item.platform_code)}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="课程分类"
                      prop="category_ids"
                      v-if="dataForm.datarange==9">
          <el-select v-model="dataForm.course_category_ids"
                     placeholder="选择分类（可多选）"
                     style="width: 300px"
                     multiple>
            <el-option v-for="item in courseCategorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资料分类"
                      prop="category_ids"
                      v-if="dataForm.datarange==9">
          <el-select v-model="dataForm.material_category_ids"
                     placeholder="选择分类（可多选）"
                     style="width: 300px"
                     multiple>
            <el-option v-for="item in materialCategorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 专栏分类 -->
        <el-form-item label="专栏分类"
                      prop="category_ids"
                      v-if="dataForm.datarange==9">
          <el-select v-model="dataForm.read_category_ids"
                     placeholder="选择分类（可多选）"
                     style="width: 300px"
                     multiple>
            <el-option v-for="item in readCategorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题库分类"
                      prop="category_ids"
                      v-if="dataForm.datarange==9">
          <el-select v-model="dataForm.exam_compose_ids"
                     placeholder="选择分类（可多选）"
                     style="width: 300px"
                     multiple>
            <el-option v-for="item in examCategorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注"
                      prop="remark">
          <el-input v-model="dataForm.remark"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <AccountChoose :visible="accountChooseDialog"
                   :content="accounts"
                   @close="accountChooseDialog = false"
                   @submit="saveAccounts"></AccountChoose>
  </div>
</template>

<script>
import AccountChoose from '@/components/dialog/select/AccountChoose'
import { adminRoleUpdate, adminRoleOne } from '@/api/admin'
import { courseCategoryList } from '@/api/course'
import { materialcategorylist } from '@/api/material'
import { readcategorylist } from '@/api/read'
import { examComposeList } from '@/api/exam'
export default {
  components: {
    AccountChoose,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {},
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        datarange: [{ required: true, message: '请选择范围', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
      accountChooseDialog: false,
      accounts: [],
      courseCategorys: [],
      materialCategorys: [],
      readCategorys: [],
      examCategorys: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchDetail(this.content.id)
      }
    },
  },
  mounted() {
    this.fetchCategoryList()
  },
  methods: {
    fetchCategoryList() {
      courseCategoryList({ status: 1, isPaging: 0 }).then((res) => {
        let list = res.list || []
        list.unshift({ id: null, name: '全部' })
        this.courseCategorys = list
      })
      materialcategorylist({ status: 1, isPaging: 0 }).then((res) => {
        let list = res.list || []
        list.unshift({ id: null, name: '全部' })
        this.materialCategorys = list
      })
      readcategorylist({ status: 1, isPaging: 0 }).then((res) => {
        let list = res.list || []
        list.unshift({ id: null, name: '全部' })
        this.readCategorys = list
      })
      examComposeList({ status: 1, isPaging: 0 }).then((res) => {
        let list = res.list || []
        list.unshift({ id: null, name: '全部' })
        this.examCategorys = list
      })
    },
    fetchDetail(id) {
      adminRoleOne({ id }).then((res) => {
        if (res) {
          this.dataForm = res
          this.accounts = res.media_account_list

          if (this.dataForm.course_category_ids) {
            let arr = this.dataForm.course_category_ids.split(',')
            this.dataForm.course_category_ids = arr.map((v) => {
              return Number(v)
            })
          }
          if (this.dataForm.material_category_ids) {
            let arr = this.dataForm.material_category_ids.split(',')
            this.dataForm.material_category_ids = arr.map((v) => {
              return Number(v)
            })
          }
          if (this.dataForm.read_category_ids) {
            let arr = this.dataForm.read_category_ids.split(',')
            this.dataForm.read_category_ids = arr.map((v) => {
              return Number(v)
            })
          }
          if (this.dataForm.exam_compose_ids) {
            let arr = this.dataForm.exam_compose_ids.split(',')
            this.dataForm.exam_compose_ids = arr.map((v) => {
              return Number(v)
            })
          }
        }
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.accounts) {
            const params = Object.assign({}, this.dataForm, {
              media_account_ids: this.accounts.length
                ? this.accounts
                    .map((v) => {
                      return v.id
                    })
                    .join(',')
                : '',
            })
            delete params.media_account_list
            adminRoleUpdate(params)
              .then((res) => {
                this.$message.success(`创建成功`)
                this.$refs['dataForm'].resetFields()
                this.$emit('submit')
                this.handleClose()
              })
              .catch((error) => {
                console.log('error: ', error)
              })
          } else {
            const params1 = Object.assign({}, this.dataForm)
            if (params1.datarange == 9) {
              params1.course_category_ids =
                this.dataForm.course_category_ids.join(',')
              params1.read_category_ids =
                this.dataForm.read_category_ids.join(',')
              params1.material_category_ids =
                this.dataForm.material_category_ids.join(',')
              params1.exam_compose_ids =
                this.dataForm.exam_compose_ids.join(',')
            }
            delete params1.media_account_list
            adminRoleUpdate(params1)
              .then((res) => {
                this.$message.success(`创建成功`)
                this.$refs['dataForm'].resetFields()
                this.$emit('submit')
                this.handleClose()
              })
              .catch((error) => {
                console.log('error: ', error)
              })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    saveAccounts(data) {
      this.accounts = data
    },
    handleTagRemove(item) {
      this.accounts = this.accounts.filter((v) => v.id !== item.id)
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: '小红书',
        2: '公众号',
        3: '微博',
        /*       4: "B站", */
        5: '知乎',
        /*      6: "抖音", */
      }
      return platform_code[val] || ''
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
.tags-wrap {
  .el-tag {
    margin: 4px;
  }
}
</style>
